export default "__VITE_ASSET__DOP2JOI2__"